<template>
  <div class="theme-provider" theme="old-theme" :data-bui-theme="buiTheme">
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import useTheme from './theme';
import '@/components/bui/tokens/nav.scss';
import '@/components/bui/themes/index.scss';

const { theme } = useTheme();
/** BUI redesign theme id (persisted as uiTheme). */
const buiTheme = computed(() => theme.value);
</script>

<style lang="scss" scoped>
.theme-provider {
  height: 100%;
  width: 100%;
}
</style>
